import { FC } from 'react';
import { StarFilled } from '@ant-design/icons';
import { Typography } from '@fuxi/eevee-ui';
import { TextProps } from 'antd/es/typography/Text';

type AvgScoreTagProps = TextProps;

export const AvgScoreTag: FC<AvgScoreTagProps> = ({ children, ...restProps }) => {
  return (
    <Typography.Text className="c-gold-6 font-s-lg text-nowrap mr-sm" {...restProps}>
      <StarFilled className="mr-xxs" />
      {children}
    </Typography.Text>
  );
};
